<template>
  <v-card
    flat
    v-if="typeof patient.species === 'number'"
    @click="cardClick(patient)"
    :height="hideDetails ? '60px' : ''"
    width="100%"
    :class="[
      'mt-2 vetalfa-card-grey-border vetalfa-pointer patient-card-hover',
      recordHeader ? 'patient-card--record' : 'px-2 py-2'
    ]"
    :id="`patient-card-${patient.id}`"
  >
    <v-icon
      x-small
      style="position: absolute; top: 42%; right: 8px; translateY(-50%)"
    >
      {{ mdiChevronRight }}
    </v-icon>
    <div v-if="recordHeader" class="patient-record-summary">
      <div class="patient-record-identity">
        <v-img
          width="36px"
          max-width="36px"
          :src="animals.getAnimalIcon(patient.species)"
          class="patient-record-avatar"
        ></v-img>
        <div class="patient-record-title">
          <p class="patient-record-name" :title="patient.name">
            {{ patient.name }}
          </p>
          <p class="patient-record-species">
            {{ animals.getAnimalShortDescription(patient.species) }}
          </p>
        </div>
      </div>

      <div
        class="patient-record-facts"
        aria-label="Dados principais do paciente"
      >
        <span v-if="patient.breed" class="patient-record-fact">{{
          patient.breed
        }}</span>
        <span class="patient-record-fact">
          <v-icon size="13" class="mr-1">{{
            animals.getSexIcon(patient.sex)
          }}</v-icon>
          {{ animals.getSexDescription(patient.sex) }}
        </span>
        <span v-if="patient.weight" class="patient-record-fact">
          {{ _formatNumber(patient.weight, "kg") }}
        </span>
        <span class="patient-record-fact">
          {{
            patient.birthday
              ? _calculateAgeFromStringBirthday(patient.birthday)
              : _formatNumber(patient.age, _getLabel("YEARS"))
          }}
        </span>
      </div>

      <div
        v-if="patient.ownerName"
        class="patient-record-owner"
        :title="patient.ownerName"
      >
        <v-icon size="14" class="mr-1">{{ _icon("user") }}</v-icon>
        <span class="patient-record-owner-label">Tutor:</span>
        <span class="patient-record-owner-name">{{ patient.ownerName }}</span>
      </div>
    </div>

    <v-row v-else class="ma-0 pa-0 pt-2 pl-1" align="start" justify="start">
      <v-img
        max-width="28px"
        :src="animals.getAnimalIcon(patient.species)"
        class="mr-3"
      ></v-img>

      <v-col :cols="10" class="ma-0 pa-0 mt-n1">
        <v-row class="ma-0 pa-0" align="start" justify="start">
          <p class="ma-0 pa-0 subtitle-2">{{ patient.name }}</p>
        </v-row>
        <v-row class="ma-0 pa-0" align="start" justify="start">
          <p class="ma-0 pa-0 items-description-label">
            {{ animals.getAnimalShortDescription(patient.species) }}
          </p>
        </v-row>
      </v-col>
      <v-col v-if="!hideDetails" cols="10" class="ma-0 pa-0 mt-4">
        <v-chip
          :small="chipSize === 'small'"
          :x-small="chipSize === 'x-small'"
          color="secondary"
          class="mr-1 mb-2 primary--text"
        >
          {{ patient.breed }}
        </v-chip>
        <v-chip
          :small="chipSize === 'small'"
          :x-small="chipSize === 'x-small'"
          color="secondary"
          class="mr-1 mb-2 primary--text"
        >
          <v-icon size="12" class="mr-1">{{
            animals.getSexIcon(patient.sex)
          }}</v-icon>
          {{ animals.getSexDescription(patient.sex) }}
        </v-chip>
        <v-chip
          v-if="patient.weight"
          :small="chipSize === 'small'"
          :x-small="chipSize === 'x-small'"
          color="secondary"
          class="mr-1 mb-2 primary--text"
        >
          {{ _formatNumber(patient.weight, "kg") }}
        </v-chip>
        <v-chip
          :small="chipSize === 'small'"
          :x-small="chipSize === 'x-small'"
          color="secondary"
          class="mr-1 mb-2 primary--text"
        >
          {{
            patient.birthday
              ? _calculateAgeFromStringBirthday(patient.birthday)
              : _formatNumber(patient.age, _getLabel("YEARS"))
          }}
        </v-chip>
        <v-chip
          :small="chipSize === 'small'"
          :x-small="chipSize === 'x-small'"
          color="secondary"
          class="mr-1 mb-2 primary--text"
        >
          <v-icon size="12" class="mr-1">{{ _icon("user") }}</v-icon>
          {{ patient.ownerName }}
        </v-chip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import animals from "@/constants/animals.enum.js";
import { mdiChevronRight } from "@mdi/js";
export default {
  name: "PatientCard",
  props: {
    patient: {
      type: Object,
      required: true
    },
    hideDetails: {
      type: Boolean,
      default: false,
      required: false
    },
    recordHeader: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      mdiChevronRight,
      animals,
      chipSize: "x-small"
    };
  },
  methods: {
    cardClick(patient) {
      this.$emit("cardClick", patient);
    }
  },
  mounted() {}
};
</script>

<style scoped>
.patient-card-hover {
  transition: box-shadow 0.2s;
}
.patient-card-hover:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}
.patient-card--record {
  min-height: 80px;
  padding: 14px 42px 14px 16px;
}
.patient-card--record > .v-icon {
  top: 50% !important;
}
.patient-record-summary {
  align-items: center;
  display: grid;
  gap: 8px 24px;
  grid-template-columns: minmax(190px, 1fr) minmax(300px, 1.4fr);
}
.patient-record-identity {
  align-items: center;
  display: flex;
  min-width: 0;
  grid-row: 1 / span 2;
}
.patient-record-avatar {
  flex: 0 0 36px;
  margin-right: 12px;
}
.patient-record-title,
.patient-record-owner {
  min-width: 0;
}
.patient-record-name {
  color: #193153;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.patient-record-species {
  color: #667085;
  font-size: 12px;
  line-height: 1.3;
  margin: 2px 0 0;
}
.patient-record-facts {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 4px 0;
  min-width: 0;
}
.patient-record-fact {
  align-items: center;
  color: #344054;
  display: inline-flex;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
}
.patient-record-fact + .patient-record-fact::before {
  color: #98a2b3;
  content: "\2022";
  margin: 0 8px;
}
.patient-record-owner {
  align-items: center;
  color: #667085;
  display: flex;
  font-size: 12px;
  line-height: 18px;
  overflow: hidden;
}
.patient-record-owner-label {
  flex: 0 0 auto;
  margin-right: 4px;
}
.patient-record-owner-name {
  color: #344054;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
@media (max-width: 599px) {
  .patient-card--record {
    min-height: 94px;
    padding: 11px 34px 11px 12px;
  }
  .patient-record-summary {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  .patient-record-identity {
    align-self: stretch;
  }
  .patient-record-avatar {
    flex-basis: 32px;
    margin-right: 10px;
    max-width: 32px !important;
    width: 32px !important;
  }
  .patient-record-name {
    font-size: 15px;
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .patient-record-facts,
  .patient-record-owner {
    align-self: stretch;
    padding-left: 42px;
  }
  .patient-record-facts {
    flex-wrap: nowrap;
    overflow: hidden;
  }
  .patient-record-fact {
    font-size: 11px;
  }
  .patient-record-fact + .patient-record-fact::before {
    margin: 0 6px;
  }
}
</style>
